import React from 'react';

import AuthContext from 'providers/auth';

class Chat extends React.Component {
  static contextType = AuthContext;

  startChat(user) {
    setTimeout(() => {
      window.Tawk_API.setAttributes({
        name: user.name,
        email: user.email,
        company: user.company.name,
      });
    }, 3000);
  }

  componentWillMount() {
    const user = this.context.me;

    const userNames = (user.name || '').split(' ');
    const firstName = userNames[0] || user.name;
    const lastName = userNames[1] || null;
    const company = user.company;

    this.startChat({
      ...user,
      firstName,
      lastName,
      company,
    });
  }

  render() {
    return null;
  }
}

export default Chat;
